(function () {
  'use strict';

  var doc = document;
  var body = doc.body;
  var routes = window.pofidikRoutes || {};
  var labels = window.pofidikTheme || {};
  var S = labels.strings || {};
  function t(key, fallback) { return S[key] != null && S[key] !== '' ? S[key] : fallback; }

  function one(selector, scope) { return (scope || doc).querySelector(selector); }
  function all(selector, scope) { return Array.prototype.slice.call((scope || doc).querySelectorAll(selector)); }
  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char];
    });
  }
  function formatAmount(cents, decimals, thousandSeparator, decimalSeparator) {
    var value = (Number(cents) || 0) / 100;
    var text = decimals ? Math.abs(value).toFixed(2) : String(Math.round(Math.abs(value)));
    var parts = text.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
    var sign = value < 0 ? '-' : '';
    return sign + (decimals ? whole + decimalSeparator + parts[1] : whole);
  }
  function money(cents) {
    var format = labels.moneyFormat || '{{amount_with_comma_separator}} TL';
    return String(format).replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
      switch (name) {
        case 'amount': return formatAmount(cents, true, ',', '.');
        case 'amount_no_decimals': return formatAmount(cents, false, ',', '.');
        case 'amount_with_comma_separator': return formatAmount(cents, true, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return formatAmount(cents, false, '.', ',');
        case 'amount_with_apostrophe_separator': return formatAmount(cents, true, "'", '.');
        case 'amount_with_space_separator': return formatAmount(cents, true, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return formatAmount(cents, false, ' ', ',');
        default: return match;
      }
    });
  }
  function lockBody() { body.classList.add('drawer-open'); }
  function unlockBody() {
    if (!one('[data-cart-drawer]:not([hidden]), [data-mobile-menu]:not([hidden]), [data-search-modal]:not([hidden])')) body.classList.remove('drawer-open');
  }

  var lastTrigger = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function focusableIn(element) {
    return all(FOCUSABLE, element).filter(function (node) {
      return !node.hidden && node.offsetParent !== null;
    });
  }

  function trapFocus(event) {
    if (event.key !== 'Tab') return;
    var layer = one('[data-cart-drawer]:not([hidden]), [data-mobile-menu]:not([hidden]), [data-search-modal]:not([hidden])');
    if (!layer) return;
    var nodes = focusableIn(layer);
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    var active = doc.activeElement;
    if (!layer.contains(active)) {
      event.preventDefault();
      first.focus();
      return;
    }
    if (event.shiftKey && active === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && active === last) { event.preventDefault(); first.focus(); }
  }

  function setExpanded(element, open) {
    if (!element || !element.id) return;
    all('[aria-controls="' + element.id + '"]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function openElement(element, trigger) {
    if (!element) return;
    lastTrigger = trigger || (doc.activeElement && doc.activeElement !== body ? doc.activeElement : null);
    element.hidden = false;
    lockBody();
    setExpanded(element, true);
    var focusTarget = one('[tabindex="-1"], input, button', element);
    if (focusTarget) window.setTimeout(function () { focusTarget.focus(); }, 30);
  }
  function closeElement(element) {
    if (!element) return;
    var wasOpen = !element.hidden;
    element.hidden = true;
    unlockBody();
    setExpanded(element, false);
    if (wasOpen && lastTrigger && doc.contains(lastTrigger)) {
      try { lastTrigger.focus(); } catch (error) {}
      lastTrigger = null;
    }
  }

  function cartEmptyMarkup() {
    return '<div class="cart-empty"><div class="empty-cart-icon">' + escapeHtml(labels.cartEmptyIcon || '🛒') + '</div><p>' + escapeHtml(labels.cartEmptyText || t('cartEmpty', 'Sepetin henüz boş.')) + '</p><a class="button button-primary" href="' + escapeHtml(labels.cartEmptyButtonLink || '/collections/all') + '">' + escapeHtml(labels.cartEmptyButtonLabel || t('cartEmptyButton', 'POFİDİK DOSTLARINI KEŞFET')) + '</a></div>';
  }

  function cartItemsMarkup(cart) {
    return '<div class="cart-items">' + cart.items.map(function (item) {
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<small>' + escapeHtml(item.variant_title) + '</small>' : '';
      var properties = Object.keys(item.properties || {}).filter(function (key) {
        return key.charAt(0) !== '_' && item.properties[key] != null && String(item.properties[key]).trim() !== '';
      }).map(function (key) {
        return '<small class="cart-line-property"><b>' + escapeHtml(key) + ':</b> ' + escapeHtml(item.properties[key]) + '</small>';
      }).join('');
      var imageSrc = item.image ? String(item.image) : '';
      var image = imageSrc ? '<img src="' + escapeHtml(imageSrc + (imageSrc.indexOf('?') > -1 ? '&' : '?') + 'width=220') + '" alt="' + escapeHtml(item.product_title) + '" width="110" height="110">' : '';
var discount = (item.line_level_discount_allocations || []).reduce(function (sum, allocation) { return sum + (Number(allocation.amount) || 0); }, 0);
var compareAt = item.compare_at_price ? Number(item.compare_at_price) : 0;
var unitPrice = Number(item.price) || 0;
var priceHtml = (compareAt > unitPrice)
  ? '<span class="cart-line-price"><s class="cart-line-compare">' + money(compareAt * item.quantity) + '</s><strong>' + money(item.final_line_price) + '</strong></span>'
  : discount > 0
    ? '<span class="cart-line-price"><s>' + money(item.original_line_price) + '</s><strong>' + money(item.final_line_price) + '</strong></span>'
    : '<strong>' + money(item.final_line_price) + '</strong>';
      var discountNotes = (item.line_level_discount_allocations || []).map(function (allocation) {
        var title = allocation.discount_application && allocation.discount_application.title;
        return '<small class="cart-line-discount">🎉 ' + escapeHtml(title || t('cartDiscount', 'İndirim')) + ' −' + money(allocation.amount) + '</small>';
      }).join('');
      return '<div class="cart-line" data-line-key="' + escapeHtml(item.key) + '">' +
        '<a href="' + escapeHtml(item.url) + '" class="cart-line-image">' + image + '</a>' +
        '<div class="cart-line-info"><a href="' + escapeHtml(item.url) + '"><strong>' + escapeHtml(item.product_title) + '</strong></a>' + variant + properties + discountNotes +
        '<div class="cart-line-bottom"><div class="quantity-control compact">' + quantityButton(item, -1, '−', t('cartDecrease', 'Azalt')) + '<span data-line-quantity>' + item.quantity + '</span>' + quantityButton(item, 1, '+', t('cartIncrease', 'Artır')) + '</div>' + priceHtml + '</div></div>' +
        '<button class="cart-line-remove" type="button" data-cart-quantity="0" data-line-key="' + escapeHtml(item.key) + '" aria-label="' + escapeHtml(t('cartRemove', 'Ürünü kaldır')) + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><path d="M19 6l-1 14c0 1-1 2-2 2H8c-1 0-2-1-2-2L5 6"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg></button></div>';
    }).join('') + '</div>';
  }

  function quantityButton(item, delta, label, ariaLabel) {
    return '<button type="button" data-cart-delta="' + delta + '" data-line-key="' + escapeHtml(item.key) + '" aria-label="' + escapeHtml(ariaLabel) + '">' + label + '</button>';
  }

  function cartPromoMarkup(cart) {
    var promo = labels.cartPromo || {};
    var tiers = promo.tiers || [];
    var realDiscount = Number(cart.total_discount) || 0;
    var qualifyingTotal = (Number(cart.total_price) || 0) + realDiscount;

    var tierStates = tiers.map(function (tier) {
      var minItems = Number(tier.minItems) || 0;
      var minTotal = Number(tier.minTotal) || 0;
      var qualified = cart.item_count >= minItems && qualifyingTotal >= minTotal;
      var active = qualified && realDiscount > 0;
      var percent = parseFloat(String(tier.value).replace('%', '')) || 0;
      var progress = minTotal > 0 ? Math.min(100, qualifyingTotal * 100 / minTotal) : 0;
      var missingTotal = minTotal - qualifyingTotal;
      var missingItems = minItems - cart.item_count;
      var savingsMoney = money(Math.round(qualifyingTotal * percent / 100));
      var note, state;
      if (active) {
        note = promo.unlocked || t('promoWon', '✓ Kazandın');
        state = 'is-active';
      } else if (qualified) {
        note = promo.qualified || t('promoQualified', 'Ödemede uygulanır');
        state = 'is-ready';
      } else if (missingItems > 0) {
        note = String(promo.lockedItems || t('promoAddMore', '[count] ürün daha ekle')).replace('[count]', missingItems);
        state = 'is-locked';
                  } else if (missingTotal > 0) {
                note = '🔥 Sepetine ' + money(missingTotal) + ' daha ekle\n' + tier.value + ' kazan!';
        state = 'is-close';
      } else {
        note = String(promo.lockedAmount || '[amount] daha ekle').replace('[amount]', money(missingTotal));
        state = 'is-locked';
      }
      return {
                html: '<div class="' + state + '"><b>' + escapeHtml(tier.value) + '</b><span>' + escapeHtml(tier.label) + '</span><div class="cart-promo-bar"><span style="width:' + progress + '%"></span></div><em>' + escapeHtml(note).replace(/\n/g, '<br>') + '</em></div>',
        qualified: qualified,
        minTotal: minTotal,
        percent: percent,
        missingTotal: missingTotal
      };
    });


        var superseded = tierStates.length === 2 && tierStates[0].qualified && tierStates[1].qualified;
    if (superseded) { tierStates[0].html = ''; }
    var grid = tierStates.map(function (s) { return s.html; }).join('');

    var upsell = '';
    if (tierStates.length >= 2 && tierStates[0].qualified && !tierStates[1].qualified) {
      var t2 = tierStates[1];
      var potential = money(Math.round(t2.minTotal * t2.percent / 100));
            upsell = '<div class="cart-promo-upsell">💡 Sepetini <b>' + escapeHtml(tiers[1].label) + '</b> yapıp <b>' + escapeHtml(tiers[1].value) + '</b> indirime ulaş! Sadece <b>' + money(t2.missingTotal) + '</b> daha ekleyip toplamda <b>' + potential + '</b> kazanabilirsin!</div>';
    }

    var saved = realDiscount > 0
      ? '<div class="cart-promo-saved">' + escapeHtml(promo.savedLabel || t('promoSaved', '💖 Bu sepette kazancın:')) + ' <b>-' + money(realDiscount) + '</b></div>'
      : '';
    var code = promo.code && cart.item_count
      ? '<a class="cart-promo-code" href="/discount/' + encodeURIComponent(promo.code) + '?redirect=' + encodeURIComponent(promo.cartUrl || '/cart') + '">' + escapeHtml(String(promo.codeLabel || '[code]').replace('[code]', promo.code)) + '</a>'
      : '';

        return '<span class="promo-badge">' + escapeHtml(promo.badge || '') + '</span><strong>' + escapeHtml(promo.title || '') + '</strong><p>' + escapeHtml(promo.text || '') + '</p><div class="cart-promo-grid' + (superseded ? ' single' : '') + '">' + grid + '</div>' + upsell + saved + code;
  }

  var cartState = null;
  var cartPageResynced = false;

  function announceCart(cartOrMessage) {
    var region = one('[data-cart-live]');
    if (!region) return;
    if (typeof cartOrMessage === 'string') { region.textContent = cartOrMessage; return; }
    var cart = cartOrMessage || {};
    var count = Number(cart.item_count) || 0;
    var template = count === 1
      ? (labels.cartLiveSingle || t('cartLiveSingle', 'Sepette [count] ürün var. Ara toplam [total].'))
      : (labels.cartLive || t('cartLive', 'Sepette [count] ürün var. Ara toplam [total].'));
    region.textContent = count
      ? String(template).replace('[count]', count).replace('[total]', money(cart.total_price))
      : (labels.cartEmptyText || t('cartEmpty', 'Sepetin henüz boş.'));
  }

  function cartFooterMarkup(cart, threshold) {
    var alwaysFreeShipping = labels.freeShippingAlways === true;
    var progress = alwaysFreeShipping ? 100 : Math.min(100, cart.total_price * 100 / threshold);
        var shippingMessage = alwaysFreeShipping || cart.total_price >= threshold
      ? (labels.freeShippingText || t('freeShipping', 'Ücretsiz Kargo'))
      : String(labels.freeShippingPendingText || t('freeShippingPending', 'Ücretsiz kargoya yaklaşıyorsun!')).replace('[amount]', money(Math.max(0, threshold - cart.total_price)));
    var discount = Number(cart.total_discount) || 0;
    var subtotalValue = discount > 0
      ? '<s class="cart-total-was">' + money(Number(cart.original_total_price) || cart.total_price) + '</s><strong data-cart-total>' + money(cart.total_price) + '</strong>'
      : '<strong data-cart-total>' + money(cart.total_price) + '</strong>';
        var shippingRow = '<div class="cart-total"><span>Kargo</span><strong>' + ((alwaysFreeShipping || cart.total_price >= threshold) ? 'Ücretsiz' : money(Number(labels.cartShippingFee) || 0)) + '</strong></div>';
    var discountRow = discount > 0
      ? '<div class="cart-total cart-total-discount"><span>Ürün İndirimi</span><strong>−' + money(discount) + '</strong></div>'
      : '';
    return '<div class="shipping-progress" data-shipping-progress data-threshold="' + threshold + '" data-shipping-always="' + alwaysFreeShipping + '"><p>' + escapeHtml(shippingMessage) + '</p><div><span style="width:' + progress + '%"></span></div></div>' +
            shippingRow +
      discountRow +
      '<div class="cart-total"><span>' + escapeHtml(labels.cartSubtotalLabel || t('cartSubtotal', 'Ara Toplam')) + '</span><span class="cart-total-values">' + subtotalValue + '</span></div>' +
      '<a class="button button-primary cart-checkout" href="' + escapeHtml(labels.cartCheckoutLink || '/checkout') + '">' + escapeHtml(labels.cartCheckoutLabel || t('cartCheckout', 'ÖDEMEYE GEÇ')) + '</a>' +
      '<a class="cart-view-link" href="' + (routes.cart || '/cart') + '">' + escapeHtml(labels.cartViewLabel || t('cartView', 'Sepeti görüntüle')) + '</a>';
  }

  function activeCodeInfo(cart) {
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      if (codes[i] && codes[i].applicable) return codes[i].code;
    }
    if (codes.length && (Number(cart.total_discount) || 0) > 0) {
      return codes[codes.length - 1].code;
    }
    return null;
  }

  function setDiscountActiveUI(wrap, code) {
    var applyRow = one('[data-discount-apply-row]', wrap);
    var activeRow = one('[data-discount-active-row]', wrap);
    var codeLabel = one('[data-discount-active-code]', wrap);
    if (applyRow) applyRow.hidden = true;
    if (activeRow) activeRow.hidden = false;
    if (codeLabel) codeLabel.textContent = '✓ ' + code + ' kodu uygulandı';
    if (wrap.tagName === 'DETAILS') wrap.open = true;
  }
  function setDiscountInactiveUI(wrap) {
    var applyRow = one('[data-discount-apply-row]', wrap);
    var activeRow = one('[data-discount-active-row]', wrap);
    if (applyRow) applyRow.hidden = false;
    if (activeRow) activeRow.hidden = true;
  }

  function cartUpsellMarkup(cart) {
    if (!labels.cartUpsellEnabled) return '';
    var map = labels.cartUpsellMap || {};
    var items = cart.items || [];
    if (!items.length) return '';
    var lastItem = items[items.length - 1];
    var target = lastItem && lastItem.handle ? map[lastItem.handle] : null;
    if (!target || !target.available) return '';
    return '<p class="cart-upsell-title">' + escapeHtml(labels.cartUpsellTitle || '🎁 Bunu da ekle!') + '</p>' +
      '<div class="cart-upsell-item">' +
        '<a href="' + escapeHtml(target.url) + '" class="cart-upsell-image"><img src="' + escapeHtml(target.image) + '" alt="' + escapeHtml(target.title) + '" loading="lazy"></a>' +
        '<div class="cart-upsell-info">' +
          '<a href="' + escapeHtml(target.url) + '"><strong>' + escapeHtml(target.title) + '</strong></a>' +
          '<span class="cart-upsell-price">' + money(target.price) + '</span>' +
        '</div>' +
        '<button type="button" class="cart-upsell-add" data-cart-upsell-add data-variant-id="' + target.variantId + '">Ekle</button>' +
      '</div>';
  }

  function renderCart(cart) {
    cartState = cart;
    all('[data-cart-count], [data-cart-drawer-count]').forEach(function (node) { node.textContent = cart.item_count; });

    all('[data-cart-content]').forEach(function (content) {
      content.innerHTML = cart.item_count ? cartItemsMarkup(cart) : cartEmptyMarkup();
    });
    all('[data-cart-promo]').forEach(function (promoWrap) {
      var activeCode = activeCodeInfo(cart);
      promoWrap.classList.toggle('is-hidden', !cart.item_count || !!activeCode);
      if (cart.item_count && !activeCode) promoWrap.innerHTML = cartPromoMarkup(cart);
    });
    all('[data-discount-form]').forEach(function (wrap) {
      var code = activeCodeInfo(cart);
      if (code) { setDiscountActiveUI(wrap, code); } else { setDiscountInactiveUI(wrap); }
    });
    all('[data-cart-upsell]').forEach(function (wrap) {
      var html = cartUpsellMarkup(cart);
      wrap.classList.toggle('is-hidden', !html);
      if (html) wrap.innerHTML = html;
    });
    all('[data-gift-note-wrap]').forEach(function (giftWrap) {
      giftWrap.classList.toggle('is-hidden', !cart.item_count);
    });
    all('[data-cart-discount-wrap]').forEach(function (discountWrap) {
      discountWrap.classList.toggle('is-hidden', !cart.item_count);
    });
    if (cart.attributes) {
      all('[data-gift-note]').forEach(function (giftInput) {
        if (doc.activeElement === giftInput) return;
        if (giftInput.dataset.giftDirty === '1') return;
        giftInput.value = cart.attributes['Hediye Notu'] || '';
        var wrapper = giftInput.closest('.cart-gift-note');
        var giftCount = wrapper && one('[data-gift-note-count]', wrapper);
        if (giftCount) giftCount.textContent = giftInput.value.length;
      });
    }
    all('[data-cart-footer]').forEach(function (footer) {
      if (!cart.item_count) {
        footer.classList.add('is-empty');
        footer.innerHTML = '';
        return;
      }
      var threshold = Number(footer.dataset.cartThreshold) || Number(one('[data-shipping-progress]', footer) && one('[data-shipping-progress]', footer).dataset.threshold) || 100000;
      footer.dataset.cartThreshold = threshold;
      footer.classList.remove('is-empty');
      footer.innerHTML = cartFooterMarkup(cart, threshold);
    });
    all('[data-cart-page-total]').forEach(function (node) { node.textContent = money(cart.total_price); });
        all('[data-cart-page-discount]').forEach(function (node) {
      var discount = Number(cart.total_discount) || 0;
      node.classList.toggle('is-hidden', discount <= 0);
      var value = one('[data-cart-page-discount-value]', node);
      if (value) value.textContent = '−' + money(discount);
    });
    all('[data-cart-page-original]').forEach(function (node) {
      var discount = Number(cart.total_discount) || 0;
      node.classList.toggle('is-hidden', discount <= 0);
      var value = one('[data-cart-page-original-value]', node);
      if (value) value.textContent = money(Number(cart.original_total_price) || cart.total_price);
    });
    var pageForm = one('[data-cart-page-form]');
    var pageEmpty = one('[data-cart-page-empty]');
    if (!cartPageResynced) {
      if (pageForm && !cart.item_count) { cartPageResynced = true; window.location.reload(); return; }
      if (pageEmpty && cart.item_count) { cartPageResynced = true; window.location.reload(); return; }
    }
    announceCart(cart);
  }

  function getCart() {
    return fetch((routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (response) { return response.json(); });
  }
  function openCart(trigger) {
    var drawer = one('[data-cart-drawer]');
    getCart().then(renderCart).catch(function () {}).finally(function () { openElement(drawer, trigger); });
  }
  function changeCart(key, quantity) {
    return fetch((routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity) || 0) })
    }).then(function (response) {
      if (!response.ok) throw new Error(t('cartUpdateError', 'Sepet güncellenemedi'));
      return response.json();
    }).then(renderCart);
  }

  var pendingQuantity = {};

  function resolveQuantity(button) {
    var key = button.dataset.lineKey;
    var delta = button.dataset.cartDelta;
    if (delta == null || delta === '') return Number(button.dataset.cartQuantity) || 0;
    var current = null;
    if (Object.prototype.hasOwnProperty.call(pendingQuantity, key)) {
      current = pendingQuantity[key];
    }
    if (current == null && cartState && cartState.items) {
      cartState.items.forEach(function (item) { if (item.key === key) current = item.quantity; });
    }
    if (current == null) {
      var line = button.closest('.cart-line');
      var display = line && one('[data-line-quantity]', line);
      current = display ? Number(String(display.textContent).trim()) : 1;
    }
    return Math.max(0, (Number(current) || 0) + (Number(delta) || 0));
  }

  function setLineBusy(key, busy) {
    all('[data-line-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]').forEach(function (node) {
      if (node.tagName !== 'BUTTON') return;
      node.disabled = busy;
      node.classList.toggle('is-busy', busy);
    });
  }

  doc.addEventListener('click', function (event) {
    var target = event.target;
    var cartOpen = target.closest('[data-cart-open]');
    var cartClose = target.closest('[data-cart-close]');
    var mobileOpen = target.closest('[data-mobile-menu-open]');
    var mobileClose = target.closest('[data-mobile-menu-close]');
    var searchOpen = target.closest('[data-search-open]');
    var searchClose = target.closest('[data-search-close]');
    var cartQuantity = target.closest('[data-cart-quantity], [data-cart-delta]');
    var upsellAdd = target.closest('[data-cart-upsell-add]');
    if (cartOpen) { event.preventDefault(); openCart(cartOpen); }
    if (cartClose) { event.preventDefault(); closeElement(one('[data-cart-drawer]')); }
    if (mobileOpen) { event.preventDefault(); openElement(one('[data-mobile-menu]'), mobileOpen); }
    if (mobileClose) { event.preventDefault(); closeElement(one('[data-mobile-menu]')); }
    if (searchOpen) { event.preventDefault(); openElement(one('[data-search-modal]'), searchOpen); }
    if (searchClose) { event.preventDefault(); closeElement(one('[data-search-modal]')); }
    if (upsellAdd) {
      event.preventDefault();
      if (upsellAdd.disabled) return;
      var upsellVariantId = upsellAdd.dataset.variantId;
      if (!upsellVariantId) return;
      var upsellOriginalText = upsellAdd.textContent;
      upsellAdd.disabled = true;
      upsellAdd.textContent = '…';
      fetch((routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: upsellVariantId, quantity: 1 })
      }).then(function (response) {
        if (!response.ok) throw new Error(t('addErrorGeneric', 'Ürün eklenemedi'));
        return getCart();
      }).then(renderCart).catch(function () {
        alert(t('addError', 'Ürün sepete eklenemedi. Lütfen tekrar deneyin.'));
      }).finally(function () {
        upsellAdd.disabled = false;
        upsellAdd.textContent = upsellOriginalText;
      });
    }
    if (cartQuantity) {
      event.preventDefault();
      if (cartQuantity.disabled) return;
      var lineKey = cartQuantity.dataset.lineKey;
      var quantity = resolveQuantity(cartQuantity);
      pendingQuantity[lineKey] = quantity;
      setLineBusy(lineKey, true);
      changeCart(lineKey, quantity)
        .catch(function (error) {
          window.console && window.console.error('Sepet güncellenemedi:', error);
          announceCart(t('cartUpdateError', 'Sepet güncellenemedi'));
          return getCart().then(renderCart).catch(function () {});
        })
        .finally(function () {
          delete pendingQuantity[lineKey];
          setLineBusy(lineKey, false);
          cartQuantity.disabled = false;
          cartQuantity.classList.remove('is-busy');
        });
    }
  });

  doc.addEventListener('keydown', trapFocus);

  doc.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeElement(one('[data-cart-drawer]'));
    closeElement(one('[data-mobile-menu]'));
    closeElement(one('[data-search-modal]'));
    var campaignClose = one('[data-campaign-modal]:not([hidden]) [data-campaign-close]');
    if (campaignClose) campaignClose.click();
  });

  function initCartSync() {
    function refresh() { getCart().then(renderCart).catch(function () {}); }
    window.addEventListener('pageshow', function (event) { if (event.persisted) refresh(); });
    doc.addEventListener('visibilitychange', function () { if (!doc.hidden) refresh(); });
  }

  var DISCOUNT_PENDING_KEY = 'pofidikPendingDiscount';

  function safeSessionSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (error) { /* özel mod */ }
  }
  function safeSessionGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (error) { return null; }
  }
  function safeSessionRemove(key) {
    try { window.sessionStorage.removeItem(key); } catch (error) { /* özel mod */ }
  }

  function activeDiscount() {
    var codes = labels.cartDiscountCodes || [];
    for (var i = 0; i < codes.length; i++) {
      if (codes[i] && codes[i].applicable) return codes[i];
    }
    return codes.length ? codes[codes.length - 1] : null;
  }

  function setDiscountStatus(text, state) {
    all('[data-discount-status]').forEach(function (status) {
      status.textContent = text;
      status.classList.toggle('is-error', state === 'error');
      status.classList.toggle('is-success', state === 'success');
    });
  }

  function reportDiscountResult() {
    var pending = safeSessionGet(DISCOUNT_PENDING_KEY);
    if (pending) {
      safeSessionRemove(DISCOUNT_PENDING_KEY);
      getCart().then(function (cart) {
        renderCart(cart);
        var codes = cart.discount_codes || [];
        var matched = false;
        for (var i = 0; i < codes.length; i++) {
          if (codes[i] && String(codes[i].code).toUpperCase() === pending.toUpperCase() && codes[i].applicable) {
            matched = true;
            break;
          }
        }
        var hasRealDiscount = (Number(cart.total_discount) || 0) > 0;
        if (matched || hasRealDiscount) {
          setDiscountStatus('', null);
        } else {
          setDiscountStatus(String(t('discountInvalid', '[code] kodu geçerli değil ya da süresi dolmuş.')).replace('[code]', pending), 'error');
        }
      }).catch(function () {
        setDiscountStatus(String(t('discountInvalid', '[code] kodu geçerli değil ya da süresi dolmuş.')).replace('[code]', pending), 'error');
      });
      return;
    }
    var active = activeDiscount();
    if (active && active.applicable) {
    }
  }

  function removeDiscount(wrap) {
    var status = one('[data-discount-status]', wrap);
    if (status) {
      status.textContent = t('discountRemoving', 'Kaldırılıyor…');
      status.classList.remove('is-error', 'is-success');
    }
    return fetch((routes.cartUpdate || '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '' })
    }).then(function (response) {
      if (!response.ok) throw new Error(t('discountRemoveErrorGeneric', 'İndirim kaldırılamadı'));
      return response.json();
    }).then(function (cart) {
      renderCart(cart);
      all('[data-discount-input]').forEach(function (input) { input.value = ''; });
      all('[data-discount-status]').forEach(function (node) {
        node.textContent = '';
        node.classList.remove('is-error', 'is-success');
      });
    }).catch(function () {
      if (status) {
        status.textContent = t('discountRemoveError', 'İndirim kaldırılamadı, tekrar dene.');
        status.classList.add('is-error');
      }
    });
  }

  function initDiscountForm() {
    function apply(wrap) {
      var input = one('[data-discount-input]', wrap);
      var status = one('[data-discount-status]', wrap);
      var code = input ? String(input.value || '').trim() : '';
      if (!code) {
        if (status) {
          status.textContent = t('discountEmpty', 'Lütfen bir indirim kodu girin.');
          status.classList.add('is-error');
          status.classList.remove('is-success');
        }
        if (input) input.focus();
        return false;
      }
      if (status) {
        status.textContent = t('discountApplying', 'Kod uygulanıyor…');
        status.classList.remove('is-error', 'is-success');
      }
      function fallbackRedirect() {
        safeSessionSet(DISCOUNT_PENDING_KEY, code);
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(routes.cart || '/cart');
      }
      fetch((routes.cartUpdate || '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code })
      }).then(function (response) {
        if (!response.ok) throw new Error(t('discountApplyErrorGeneric', 'Kod uygulanamadı'));
        return response.json();
      }).then(function (cart) {
        renderCart(cart);
        var applied = activeCodeInfo(cart);
        if (applied && applied.toUpperCase() === code.toUpperCase()) {
          if (status) {
            status.textContent = '';
            status.classList.remove('is-error', 'is-success');
          }
        } else {
          fallbackRedirect();
        }
      }).catch(function () {
        fallbackRedirect();
      });
      return true;
    }
    reportDiscountResult();
    all('[data-discount-form]').forEach(function (wrap) {
      var button = one('[data-discount-apply]', wrap);
      if (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          apply(wrap);
        });
      }
      var input = one('[data-discount-input]', wrap);
      if (input) {
        input.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          event.stopPropagation();
          apply(wrap);
        });
      }
      wrap.addEventListener('submit', function (event) {
        event.preventDefault();
        apply(wrap);
      });

      var removeButton = one('[data-discount-remove]', wrap);
      if (removeButton) {
        removeButton.addEventListener('click', function (event) {
          event.preventDefault();
          removeDiscount(wrap);
        });
      }

      var pageForm = wrap.closest('form[data-cart-page-form]');
      if (pageForm) {
        pageForm.addEventListener('submit', function (event) {
          var pendingCode = input ? String(input.value || '').trim() : '';
          if (!pendingCode) return;
          event.preventDefault();
          apply(wrap);
        });
      }
    });
  }

  function initProduct() {
    var section = one('[data-product-section]');
    if (!section) return;
    var form = one('.product-form', section);
    var quantityInput = one('[data-quantity-input]', section);
    var media = all('[data-product-gallery] .product-media', section);
    var thumbs = all('[data-product-gallery] .product-thumbnail', section);
    var currentMedia = 0;
    function showMedia(index) {
      if (!media.length) return;
      currentMedia = (index + media.length) % media.length;
      media.forEach(function (node, i) { node.classList.toggle('is-active', i === currentMedia); });
      thumbs.forEach(function (node, i) { node.classList.toggle('is-active', i === currentMedia); });
    }
    thumbs.forEach(function (thumb) { thumb.addEventListener('click', function () { showMedia(Number(thumb.dataset.mediaIndex)); }); });
    var prev = one('[data-gallery-prev]', section); var next = one('[data-gallery-next]', section);
    if (prev) prev.addEventListener('click', function () { showMedia(currentMedia - 1); });
    if (next) next.addEventListener('click', function () { showMedia(currentMedia + 1); });
    var minus = one('[data-quantity-minus]', section); var plus = one('[data-quantity-plus]', section);
    var bundles = all('input[name="bundle"]', section);
    function syncBundleFromQuantity() {
      var value = String(Number(quantityInput.value) || 1);
      var matched = false;
      bundles.forEach(function (input) {
        input.checked = input.value === value;
        if (input.checked) matched = true;
      });
      if (!matched) bundles.forEach(function (input) { input.checked = false; });
    }
    function setQuantity(value) {
      quantityInput.value = Math.min(10, Math.max(1, Number(value) || 1));
      syncBundleFromQuantity();
    }
    if (minus) minus.addEventListener('click', function () { setQuantity(Number(quantityInput.value) - 1); });
    if (plus) plus.addEventListener('click', function () { setQuantity(Number(quantityInput.value) + 1); });
    quantityInput.addEventListener('change', function () { setQuantity(quantityInput.value); });
    quantityInput.addEventListener('input', syncBundleFromQuantity);
    bundles.forEach(function (input) {
      input.addEventListener('change', function () { quantityInput.value = input.value; });
    });
    syncBundleFromQuantity();

    var json = one('[data-product-json]', section);
    var variants = json ? JSON.parse(json.textContent) : [];
    function updateVariant() {
      var selected = all('.variant-picker', section).map(function (picker) { var checked = one('input:checked', picker); return checked ? checked.value : ''; });
      var variant = variants.find(function (item) { return item.options.every(function (option, index) { return option === selected[index]; }); });
      if (!variant) return;
      one('[data-variant-id]', form).value = variant.id;
      var price = one('[data-product-price]', section);
      if (price) {
        var discount = variant.compare_at_price > variant.price ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
        price.innerHTML = (discount ? '<span style="background:#ff4444;color:#fff;padding:5px 14px;border-radius:4px;font-size:14px;font-weight:700;display:inline-flex;align-items:center;justify-content:center;line-height:1.4;white-space:nowrap;">%' + discount + ' İNDİRİM</span>' : '') + '<div>' + (variant.compare_at_price > variant.price ? '<s>' + money(variant.compare_at_price) + '</s>' : '') + '<strong>' + money(variant.price) + '</strong></div>';
      }
      var button = one('.add-to-cart', form);
      button.disabled = !variant.available;
      one('[data-add-to-cart-text]', form).textContent = variant.available ? (button.dataset.addToCartDefault || t('addToCart', 'SEPETE EKLE')) : t('soldOut', 'TÜKENDİ');
    }
    all('.variant-picker input', section).forEach(function (input) { input.addEventListener('change', updateVariant); });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var button = one('.add-to-cart', form);
      button.disabled = true;
      one('[data-add-to-cart-text]', form).textContent = t('adding', 'EKLENİYOR...');
      fetch((routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (response) { if (!response.ok) throw new Error(t('addErrorGeneric', 'Ürün eklenemedi')); return response.json(); })
        .then(openCart)
        .catch(function () { alert(t('addError', 'Ürün sepete eklenemedi. Lütfen tekrar deneyin.')); })
        .finally(function () { button.disabled = false; one('[data-add-to-cart-text]', form).textContent = button.dataset.addToCartDefault || 'SEPETE EKLE'; });
    });
    var buyNow = one('[data-buy-now]', section);
    if (buyNow) buyNow.addEventListener('click', function () {
      buyNow.disabled = true;
      fetch((routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (response) { if (!response.ok) throw new Error(); window.location.href = '/checkout'; })
        .catch(function () { buyNow.disabled = false; alert(t('checkoutError', 'Ödeme adımına geçilemedi.')); });
    });
    var viewer = one('[data-viewer-count]', section);
    if (viewer) {
      var viewerMin = Number(viewer.dataset.viewerMin || 3);
      var viewerMax = Math.max(viewerMin, Number(viewer.dataset.viewerMax || 7));
      viewer.textContent = String(Math.floor(Math.random() * (viewerMax - viewerMin + 1)) + viewerMin);
    }
  }

  function initPopups() {
    var campaign = one('[data-campaign-modal]');
    var popupKey = 'pofidik_campaign_seen_v2';
    function storageGet(storage, key) { try { return storage.getItem(key); } catch (error) { return null; } }
    function storageSet(storage, key, value) { try { storage.setItem(key, value); } catch (error) {} }
    function popupCanOpen() {
      if (!campaign) return false;
      var frequency = campaign.dataset.popupFrequency || 'session';
      if (frequency === 'always') return true;
      if (frequency === 'session') return !storageGet(window.sessionStorage, popupKey);
      var seenAt = Number(storageGet(window.localStorage, popupKey)) || 0;
      var days = frequency === 'daily' ? 1 : Number(campaign.dataset.popupDays || 7);
      return !seenAt || Date.now() - seenAt >= days * 86400000;
    }
    function markPopupSeen() {
      if (!campaign) return;
      var frequency = campaign.dataset.popupFrequency || 'session';
      if (frequency === 'session') storageSet(window.sessionStorage, popupKey, '1');
      if (frequency === 'daily' || frequency === 'days') storageSet(window.localStorage, popupKey, String(Date.now()));
    }
    function closeCampaign() {
      if (campaign) campaign.hidden = true;
      markPopupSeen();
      body.classList.remove('modal-open');
    }
    if (popupCanOpen()) {
      var popupDelay = Math.max(0, Number(campaign.dataset.popupDelay || 1)) * 1000;
      window.setTimeout(function () { campaign.hidden = false; body.classList.add('modal-open'); }, popupDelay);
    }
    all('[data-campaign-close]').forEach(function (button) { button.addEventListener('click', closeCampaign); });
    all('.campaign-card a', campaign || doc).forEach(function (link) { link.addEventListener('click', markPopupSeen); });
    var cookie = one('[data-cookie-banner]');
    if (cookie && !storageGet(window.localStorage, 'pofidik_cookie_accepted')) cookie.hidden = false;
    var accept = one('[data-cookie-accept]');
    if (accept) accept.addEventListener('click', function () { storageSet(window.localStorage, 'pofidik_cookie_accepted', '1'); cookie.hidden = true; });
  }

  function initGiftNote() {
    all('[data-gift-note]').forEach(function (input) {
      var wrapper = input.closest('.cart-gift-note');
      var count = one('[data-gift-note-count]', wrapper);
      var status = one('[data-gift-note-status]', wrapper);
      var timer;
      function updateCount() { if (count) count.textContent = input.value.length; }
      updateCount();
      function save() {
        window.clearTimeout(timer);
        if (input.dataset.giftDirty !== '1') return Promise.resolve();
        var value = input.value.trim();
        return fetch((routes.cartUpdate || '/cart/update') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Hediye Notu': value } })
        }).then(function (response) {
          if (!response.ok) throw new Error('Hediye notu kaydedilemedi');
          return response.json();
        }).then(function () {
          if (input.value.trim() === value) input.dataset.giftDirty = '0';
          if (status) status.textContent = t('cartNoteSaved', 'Kaydedildi ✓');
        }).catch(function () {
          if (status) status.textContent = 'Kaydedilemedi';
        });
      }
      input.giftNoteSave = save;
      input.addEventListener('input', function () {
        updateCount();
        input.dataset.giftDirty = '1';
        if (status) status.textContent = 'Kaydediliyor…';
        window.clearTimeout(timer);
        timer = window.setTimeout(save, 550);
      });
      input.addEventListener('blur', function () { save(); });
    });
  }

  function initFaqs() {
    all('[data-faq-accordion]').forEach(function (accordion) {
      if (accordion.dataset.allowMultiple === 'true') return;
      all('details', accordion).forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          all('details', accordion).forEach(function (other) { if (other !== item) other.open = false; });
        });
      });
    });
  }

function initDeliveryTimeline() {
  function nextWorkday(date) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    d.setDate(d.getDate() + 1);
    while (d.getDay() === 0) d.setDate(d.getDate() + 1);
    return d;
  }

  function addWorkdays(date, count) {
    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var remaining = Math.max(0, Number(count) || 0);
    while (remaining > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) remaining -= 1;
    }
    return d;
  }

  function dateText(date) {
    return new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'long' }).format(date);
  }

  all('[data-delivery-timeline]').forEach(function (timeline) {
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var hour = now.getHours();
    var day = now.getDay();

    var cargoDay;
    if (hour < 17 && day !== 0) {
      cargoDay = today;
    } else {
      cargoDay = nextWorkday(today);
    }

    all('[data-delivery-step]', timeline).forEach(function (step) {
      var offsetMin = parseInt(step.dataset.offsetMin) || 0;
      var offsetMax = parseInt(step.dataset.offsetMax || step.dataset.offsetMin) || 0;
      var output = one('[data-delivery-date]', step);
      if (!output) return;

      var minDate, maxDate;

      if (offsetMin === 0 && offsetMax === 0) {
        minDate = today;
        maxDate = today;
      } else if (offsetMin === 1 && offsetMax === 1) {
        minDate = cargoDay;
        maxDate = cargoDay;
      } else {
        minDate = addWorkdays(cargoDay, offsetMin - 1);
        maxDate = addWorkdays(cargoDay, offsetMax - 1);
      }

      output.textContent = minDate.getTime() === maxDate.getTime()
        ? dateText(minDate)
        : dateText(minDate) + ' – ' + dateText(maxDate);
    });
  });
}




  function initSort() {
    var sort = one('#SortBy');
    if (!sort) return;
    var selected = new URLSearchParams(window.location.search).get('sort_by');
    if (selected) sort.value = selected;
  }

  function initAnnouncements() {
    var items = all('[data-announcement-item]');
    if (items.length < 2) return;
    var track = one('[data-announcement-track]');
    var speed = Math.max(1000, Number(track && track.dataset.announcementSpeed) || 3200);
    var active = 0;
    items.forEach(function (item, index) {
      if (item.classList.contains('is-active')) active = index;
    });
    var show = function (index) {
      items.forEach(function (item, i) {
        var on = i === index;
        item.classList.toggle('is-active', on);
        item.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
    };
    show(active);
    window.setInterval(function () {
      active = (active + 1) % items.length;
      show(active);
    }, speed);
  }

  function initCustomerForms() {
    var loginCard = doc.getElementById('CustomerLogin');
    var recoverCard = doc.getElementById('RecoverPassword');
    if (loginCard && recoverCard) {
      var showRecover = function (show) {
        recoverCard.hidden = !show;
        loginCard.hidden = show;
        var focusTarget = one('input', show ? recoverCard : loginCard);
        if (focusTarget) focusTarget.focus();
      };
      all('[data-recover-show]').forEach(function (button) {
        button.addEventListener('click', function () { showRecover(true); });
      });
      all('[data-recover-hide]').forEach(function (button) {
        button.addEventListener('click', function () { showRecover(false); });
      });
      if (window.location.hash === '#recover' || one('.newsletter-message', recoverCard)) showRecover(true);
    }

    all('[data-address-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var target = doc.getElementById(button.getAttribute('data-address-toggle'));
        if (!target) return;
        target.hidden = !target.hidden;
        if (!target.hidden) {
          var field = one('input', target);
          if (field) field.focus();
        }
      });
    });

    all('[data-address-delete]').forEach(function (button) {
      button.addEventListener('click', function () {
        var message = button.getAttribute('data-confirm') || '?';
        if (!window.confirm(message)) return;
        var form = doc.createElement('form');
        form.method = 'post';
        form.action = button.getAttribute('data-address-delete');
        form.innerHTML = '<input type="hidden" name="_method" value="delete">';
        doc.body.appendChild(form);
        form.submit();
      });
    });

    var countrySelects = all('[data-address-country]');
    if (countrySelects.length) {
      countrySelects.forEach(function (countrySelect) {
        var wrapper = countrySelect.closest('.customer-form-row') || doc;
        var provinceSelect = one('[data-address-province]', wrapper);
        var provinceWrapper = provinceSelect && provinceSelect.closest('[data-address-province-wrapper]');
        if (countrySelect.dataset.default) countrySelect.value = countrySelect.dataset.default;

        var syncProvinces = function () {
          if (!provinceSelect) return;
          var option = countrySelect.options[countrySelect.selectedIndex];
          var provinces = [];
          try { provinces = JSON.parse(option.getAttribute('data-provinces') || '[]'); } catch (error) { provinces = []; }
          provinceSelect.innerHTML = '';
          if (!provinces.length) {
            if (provinceWrapper) provinceWrapper.hidden = true;
            return;
          }
          if (provinceWrapper) provinceWrapper.hidden = false;
          provinces.forEach(function (pair) {
            var opt = doc.createElement('option');
            opt.value = pair[0];
            opt.textContent = pair[1];
            provinceSelect.appendChild(opt);
          });
          if (provinceSelect.dataset.default) provinceSelect.value = provinceSelect.dataset.default;
        };

        countrySelect.addEventListener('change', syncProvinces);
        syncProvinces();
      });
    }
  }

  function initPasswordPage() {
    var toggle = one('[data-password-toggle]');
    var form = doc.getElementById('PasswordLoginForm');
    if (!toggle || !form) return;
    if (one('.newsletter-message.error', form)) form.hidden = false;
    toggle.addEventListener('click', function () {
      form.hidden = !form.hidden;
      if (!form.hidden) {
        var field = one('input', form);
        if (field) field.focus();
      }
    });
  }

  function initCopyButtons() {
    all('[data-copy-target]').forEach(function (button) {
      button.addEventListener('click', function () {
        var target = doc.getElementById(button.getAttribute('data-copy-target'));
        if (!target) return;
        var text = (target.textContent || '').trim();
        var done = function () {
          var original = button.textContent;
          button.textContent = button.getAttribute('data-copied-label') || original;
          window.setTimeout(function () { button.textContent = original; }, 2000);
        };
        var fallback = function () {
          var helper = doc.createElement('textarea');
          helper.value = text;
          helper.setAttribute('readonly', '');
          helper.style.position = 'absolute';
          helper.style.left = '-9999px';
          doc.body.appendChild(helper);
          helper.select();
          try { doc.execCommand('copy'); } catch (error) {}
          doc.body.removeChild(helper);
          done();
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done, fallback);
        } else {
          fallback();
        }
      });
    });
  }

  initProduct();

  initCartSync();
  initDiscountForm();
  initPopups();
  initGiftNote();
  initFaqs();
  initDeliveryTimeline();
  initSort();
  initAnnouncements();
  initCustomerForms();
  initPasswordPage();
  initCopyButtons();
})();
